/* eslint-disable react-hooks/exhaustive-deps */
import  { useEffect, useState, Suspense, lazy } from 'react';
import * as microsoftTeams from '@microsoft/teams-js';
//import { useMsal } from "@azure/msal-react";
import axios from "axios";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import Install from "./pages/Install";
import { bindTeamsData } from "./store/donationSlice";
import CryptoJS from "crypto-js";
import Protected from "./pages/Protected";
import Loading from "./pages/Loading";
import PublishForm from "./pages/PublishForm";
import  { SALT_KEY, API_BASE_URL }  from "./utility/constants";
import Success from "./pages/Success";

//import Welcome from './pages/Welcome';
import { extractEmailParts, getAttributeValue } from './utility/util';
import InvitationModal from './pages/InvitationModal';
import ConfigPage from './pages/Config';
import AuthPage from './pages/Auth';
import MobileInvite from './pages/MobileInvitation';
import RemoveTab from './pages/RemoveTab';
// import { useMsal } from '@azure/msal-react';
// import { InteractionStatus } from '@azure/msal-browser';
// import { msalInstance } from './utility/msalConfig';




const HostPage = lazy(() => import("./pages/HostLanding"));
const UserPage = lazy(() => import("./pages/UserDonationHome"));

//import ThirdPartyPayments from './components/ThridPartyPayments';


const App = () => {

    const [userContext, setUserContext] = useState(null);
    const [frameContext, setFrameContext] = useState(null);
    const [apptype, setApptype] = useState(null);
    const [meetingId, setMeetingId] = useState(null);
    const [userinfo, setUserInfo] = useState({});
    const [useraccountinfo, setUserAccountInfo] = useState({});
    const [meetingUUID, setMeetingUUID] = useState("");
    const [chatId, setChatId] = useState("");
    const [appoutofcontext, setAppOutOfContext] = useState(false);
    const [isExistingForm, setIsExistingForm] = useState(false);
    const [checkFormExists, setCheckFormExists] = useState("");
    const [appinbrowser, setAppInBrowser] = useState(false);
    const [appcontext, setAppRunningContext] = useState(false);

    //const { instance, accounts, inProgress  } = useMsal();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

      const onAllow = (token) => {
      
           microsoftTeams.dialog.url.submit({message:"allow"})
        }
    
        const onDeny = () => {
        
          microsoftTeams.dialog.url.submit({message:"deny"})
         
        }

  
      
    useEffect(() => {
      // 1. Check if admin consent required
      microsoftTeams.app.initialize().then(()=>{
          // if(accounts[0]){
          //     instance.handleRedirectPromise().then((response) => {
          //       if (response) {
          //         console.log("Redirect login completed, access token:", response.accessToken);
          //         microsoftTeams.authentication.notifySuccess(response.accessToken); // Send token back to Teams
          //       }
          //     }).catch((error) => {
          //       console.error("Redirect error:", error);
          //       microsoftTeams.authentication.notifyFailure(error.message || "Redirect failed");
          //     });
          // }
        
              microsoftTeams.app.getContext().then(async(context) => {
                console.log("context==",context)
                  setUserContext(context.user);
                  setApptype(context.app.host);
                  setFrameContext(context.page?.frameContext);
                  
                  if(context.meeting){

                     localStorage.setItem('chatId', context?.chat?.id);
                    //Get Active subscriptions
                    await getActiveSubscription(context.user?.tenant?.id);
                      
                
                 //createdbInstance(context.meeting.id, context.user?.id);
                  if(context.page?.frameContext !== "task"){
                    microsoftTeams.meeting.getMeetingDetails(async(error, meetingDetails) => {
                       const MeetId = context.chat.id.replace('19:meeting_', '').replace(/@thread.*/g, '');
                      if (error) {
                    
                        let isnotMeeting = false;
                           if(!isnotMeeting) {
                            navigate("/");
                            isnotMeeting = true;
                           }
                            //call createdb instance for 1:1 or groupcall
                              
                               if(!sessionStorage.getItem("role") || !meetingUUID) createdbInstance(MeetId, context.user?.id,"");
                             
                          
                      } else {
                        // if(meetingDetails?.details?.joinUrl){
                        //   const organizersDetails = await loginAndFetchMeetingOrganizers(meetingDetails.details.joinUrl, context.user?.id);
                        //   console.log("organizers==",organizersDetails);
                        // }
                        console.log("Meeting Details:", meetingDetails);
                        if(meetingDetails.organizer && meetingDetails.organizer.id === context.user?.id){
                          
                           setUserInfo({role: "host"});
                          //sessionStorage.setItem("role", "host");
                          if(!sessionStorage.getItem("role") || !meetingUUID) createdbInstance(MeetId, context.user?.id,"");
                        }else{
                          
                           if(sessionStorage.getItem("role")) setUserInfo({role: sessionStorage.getItem("role")});
                              // Optimistically set attendee role
                                if(!sessionStorage.getItem("role")) {
                                  sessionStorage.setItem("role", "Attendee");
                                  setUserInfo({ role: "Attendee" });
                                } else {
                                  setUserInfo({ role: sessionStorage.getItem("role") });
                                }

                                // Always ensure db instance is created in background
                                if(!meetingUUID) {
                                  createdbInstance(MeetId, context.user?.id,"Attendee");
                                }
                          //sessionStorage.setItem("role", "Attendee");
                          // if(!sessionStorage.getItem("role") || !meetingUUID) {
                          //    if(meetingDetails.organizer && meetingDetails.organizer.id) {
                          //     createdbInstance(MeetId, context.user?.id,"Attendee");
                          //    }else{
                          //     createdbInstance(MeetId, context.user?.id,"");
                          //    }
                          // }
                        }
                      

                      }
                    });
                  }
                   
                   getUserData(context);
                   
                  if(!isExistingForm && location.pathname !== "/invite" && location.pathname !== "/config"){
                    setCheckFormExists("started");
                    const userparams = {
                      eId: sessionStorage.getItem("MID")? sessionStorage.getItem("MID") : context.chat.id.replace('19:meeting_', '').replace(/@thread.*/g, ''),
                    };
                  
                    let postBody = CryptoJS.AES.encrypt(
                      JSON.stringify({ body: { userparams } }),
                      SALT_KEY
                    ).toString(); 
                    const responseformexists = await axios.post(`${API_BASE_URL}`,{ httpMethod: "POST", path: "/getuserform", postBody });
                   
                    if(responseformexists.data && responseformexists.data.body && responseformexists.data.body.Items){
                     // const guid = responseformexists.data.body.Items[0].Attributes[3].Value;
                      const guid = getAttributeValue(responseformexists.data.body.Items[0].Attributes, "GiventID");
                     
                      if (guid) {
                       
                        setIsExistingForm(true);
                        setCheckFormExists("finished");
                        navigate("/loadform", { state: { showDForm: true } });
                      }
                    }
                    setCheckFormExists("finished");
                  }
                
                  
                   }else{
                    //if(!sessionStorage.getItem("MID")) setAppOutOfContext(true);
                    setAppOutOfContext(true);
                   }
                    
                 
                });

             
              
              
        }).catch(err => {
         
          setAppInBrowser(true);
          setAppOutOfContext(true);
        });
    
        return () => {
          console.log("cleaned up");
        };
       
      // eslint-disable-next-line react-hooks/exhaustive-deps
      }, []);

 

const getUserData = async(context) => {
                      let dname="",fname="",lname="";
                    const userparams = {
                      httpMethod:'POST',
                      path:'/getuserfromgraph',
                      body:{
                          userId: context.user?.id,
                          tId: context.user?.tenant?.id
                      }
                   };
                   const uresponse =  await axios.post(`${API_BASE_URL}`,userparams);
                   let udata;
                   if(uresponse.data.body && uresponse.data.body){
                      udata = JSON.parse(uresponse.data.body);
                  
                     dname = udata.displayName;
                     fname = udata.givenName;
                      lname = udata.surname;
                     
                   }

                     
                      if(!dname){
                            const parts = extractEmailParts(context.user?.userPrincipalName);
                              if (parts.length > 0) {
                                if(parts.length >=2) {
                                  dname = parts[0].charAt(0).toUpperCase() + parts[0].slice(1) + ' '+ parts[1].charAt(0).toUpperCase() + parts[1].slice(1);
                                  fname = parts[0].charAt(0).toUpperCase() + parts[0].slice(1);
                                  lname = parts[1].charAt(0).toUpperCase() + parts[1].slice(1)
                                }else{
                                  dname = parts[0].charAt(0).toUpperCase() + parts[0].slice(1);
                                  fname = parts[0].charAt(0).toUpperCase() + parts[0].slice(1);
                                }
                              } 
                          }
                    const MeetId = context.chat.id.replace('19:meeting_', '').replace(/@thread.*/g, '');
                    const teamsuserinfo = {
                      email: udata.mail ? udata.mail : context.user?.userPrincipalName,
                      display_name: dname,
                      first_name: fname,
                      last_name: lname,
                      userId: context.user?.id,
                      accountId: context.user?.tenant?.id,
                      hostId: context.user?.id,
                      meetingId: MeetId,
                      startTime: new Date().toString()
                    }
                  
                    setUserAccountInfo(teamsuserinfo);
                  
                    dispatch(bindTeamsData(teamsuserinfo));
                    setChatId(context?.chat?.id);
                    setAppRunningContext(context.app?.host?.clientType);
                    setMeetingId(MeetId);
                   
}
const createdbInstance = async(mId, userId, isrole) => {
     
      // if(!sessionStorage.getItem("MID")){
          const params = {
          httpMethod:'POST',
          path:'/createdbinstance',
          body:{
              tableName: mId,
              uId: userId,
              isRole: isrole
          }
        };
      const response =  await axios.post(`${API_BASE_URL}`,params);

      if(response.data.body){
      const msg = JSON.parse(response.data.body);
  
        if(msg.message) {
          setUserInfo({role: msg.message});
          setMeetingUUID(msg.mId);
          sessionStorage.setItem("MID", msg.mId);
          sessionStorage.setItem("role", msg.message);
        }
        
      }
   // }
};


 const getActiveSubscription = async(tenentId) => {
      const params = {
        httpMethod:'POST',
        path:'/getactivesub',
        body:{
            tId: tenentId
        }
     };
        const response =  await axios.post(`${API_BASE_URL}`,params);
        const activesub = JSON.parse(response.data.body);
      
        if(activesub && activesub.value){
          if(activesub && activesub.value.length === 0) createSubscription(tenentId);
        }
     };

 const createSubscription = async(tenentId) =>{
       
      const params = {
        httpMethod:'POST',
        path:'/createsubscription',
        body:{
            tId: tenentId
        }
      };
        const response =  await axios.post(`${API_BASE_URL}`,params);
        console.log("cresteSubscription==",response)
     };

// const loginAndFetchMeetingOrganizers = async (joinUrl, uid) => {
//         try {
//           const scopes = ["OnlineMeetings.Read", "OnlineMeetings.ReadWrite"];
//             // Ensure user is signed in
//             if (accounts.length === 0) {
//                 await instance.loginPopup({ scopes });
//             }
//             if (accounts.length > 0) {
//                 instance.setActiveAccount(accounts[0]);
//             }
//             console.log("accounts==",accounts)
//             // Get access token
//             const tokenResponse = await instance.acquireTokenSilent({
//                 scopes,
//                 account: accounts[0],
//             });

//             // Call Graph API
//             const response = await axios.get(`https://graph.microsoft.com/v1.0/users/${uid}/onlineMeetings/?$filter=JoinWebUrl eq '${joinUrl}'`, {
//                 headers: { Authorization: `Bearer ${tokenResponse.accessToken}` },
//             });

//             //Get the meeting co-organizers
//             const resdata = await response?.data?.value[0]?.participants.attendees.filter(attendee => attendee.role !== "attendee") || {};
//             console.log("meeting data==",resdata);
//             return resdata;
//         } catch (error) {
//             console.error("Error fetching meeting organizers:", error);
//             return null;
//         }
//     };



    return (
        <>
           

    <Suspense fallback={<Loading appoutofcontext={appoutofcontext} />}>
      <Routes>
       
       {Object.keys(useraccountinfo).length && (Object.keys(userinfo).length || sessionStorage.getItem("role")) && (
          <Route
            exact
            path="/"
            element={
              <Protected
                isHost={(Object.keys(userinfo).length ? userinfo.role : sessionStorage.getItem("role")) === "host"}
              >
                {checkFormExists === "finished" && !isExistingForm ? (
                  <>
                 
                    <HostPage
                    meetingData={meetingUUID}
                    userData={useraccountinfo}
                    appcontext={appcontext}
                  />
                 
                  </>
                ) : (
                  <Loading />
                )}
              </Protected>
            }
          />
        )}
        
         {Object.keys(useraccountinfo).length && (Object.keys(userinfo).length || sessionStorage.getItem("role")) && (
          <Route
            exact
            path="/tab"
            element={
              <Protected
                isHost={(Object.keys(userinfo).length ? userinfo.role : sessionStorage.getItem("role")) === "host"}
              >
                {checkFormExists === "finished" && !isExistingForm ? (
                  <>
                 
                    <HostPage
                    meetingData={meetingUUID}
                    userData={useraccountinfo}
                    appcontext={appcontext}
                  />
                 
                  </>
                ) : (
                  <Loading />
                )}
              </Protected>
            }
          />
        )}

       {Object.keys(useraccountinfo).length && (Object.keys(userinfo).length || sessionStorage.getItem("role")) && (
          <Route
            exact
            path="/home"
            element={
              <Protected
                isHost={(Object.keys(userinfo).length ? userinfo.role : sessionStorage.getItem("role")) === "host"}
              >
                {checkFormExists === "finished" && !isExistingForm ? (
                  <>
                 
                    <HostPage
                    meetingData={meetingUUID}
                    userData={useraccountinfo}
                    appcontext={appcontext}
                  />
                 
                  </>
                ) : (
                  <Loading />
                )}
              </Protected>
            }
          />
        )}
      
          <Route
            exact
            path="/publishform"
            element={
              <Protected
                isHost={(Object.keys(userinfo).length ? userinfo.role : sessionStorage.getItem("role")) === "host"}
               
              >
                <PublishForm
                  meetingData={meetingUUID}
                  userData={useraccountinfo}
                  chatId={chatId}
                  appcontext={appcontext}
                  meetingId={meetingId}
                />
              </Protected>
            }
          />
       
          <Route
            exact
            path="/loadform"
            element={
              <>
              
              <UserPage
              meetingData={meetingUUID}
              userData={useraccountinfo}
              ishost={(Object.keys(userinfo).length ? userinfo.role : sessionStorage.getItem("role")) === "host"}
              
            
            />
             
             </>
            }
          />
           {/* <Route path="/" element={ <Welcome context={userContext} appType={apptype} meetingContext={meetingContext} formData={formData} />} /> */}
         {!Object.keys(userinfo).length && !appoutofcontext && (
          <Route
            path="/"
            element={<Loading appoutofcontext={appoutofcontext} />}
          />
        )} 
        { !appinbrowser && appoutofcontext && (
          <Route
            path="/"
            element={<Loading appoutofcontext={appoutofcontext} />}
          />
        )}
        {appinbrowser && <Route path="/" element={<Install />} />}
      
        <Route path="/config" element={<ConfigPage />} />
        <Route path="/loading" element={<Loading />} />
        <Route path="/auth" element={<AuthPage />} />
        <Route path="/success" element={<Success donateAgain={true} frameContext={frameContext} />} />
        <Route path="/invite" element={<InvitationModal onAllow={onAllow} onDeny={onDeny}/>} />
        <Route path="/minvite" element={<MobileInvite chatId={chatId} />} />
        <Route path="/remove" element={<RemoveTab />} />
        <Route path="*" element={<Loading />} />
      </Routes>
    </Suspense>



        </>
    );
};

export default App;
